import { Provider, EnvironmentProviders } from "@angular/core";
import { AdminGuard } from "./admin.guards";
import { EventHostGuard } from "./event-host.guard";
import { EventSystemGuard } from './event-system.guard'
import { AuthGuard } from "./auth.guard";
import { LoginGuard } from "./login.guard";
import { OrganiserGuard } from "./organiser.guard";

export const guards: (Provider | EnvironmentProviders)[] = [
    AuthGuard,
    LoginGuard,
    AdminGuard,
    EventHostGuard,
    EventSystemGuard,
    OrganiserGuard
]